@if (hasMultiplePractices()) {
  <p class="font-bold">{{ practiceName() }}</p>
}

<mat-slide-toggle
  [formControl]="includeDepositsInAllocations"
  [disabled]="saving()"
  (change)="onToggleChange($event.checked)"
>
  Include deposits in practitioner allocation
</mat-slide-toggle>
